import { defineStore } from 'pinia'
import { nextTick, ref, watch } from 'vue'
import type { Language } from 'element-plus/es/locale'
import { useAppContext } from '@/stores/appContext'
const messageModules=import.meta.glob('./el/*.mjs');

export const useElementPlusLocale = defineStore("elementPlusLocale", () => {
  const appContext = useAppContext();
  const localizationMap = new Map<string, Language>();
  const locale = ref<Language>();
  const loadLocaleMessages = async (localeName: string) => {
    localeName = localeName.toLowerCase();
    if (localizationMap.has(localeName)) {
      locale.value = localizationMap.get(localeName);
    }
    try {
      const importMethod=messageModules[`./el/${localeName}.mjs`];
      if(!importMethod) {
        return;
      }
      const messageModule:any=await importMethod();
      const messages = messageModule?.default;
      locale.value = messages;
      localizationMap.set(localeName, messages.default);
      return nextTick()
    }
    catch (error: any) {
      if (import.meta.env.DEV) {
        localizationMap.set(localeName, { name: localeName, el: {} });
        locale.value = localizationMap.get(localeName);
      }
      console.error(error);
    }
  }
  watch(() => appContext.locale, async () => {
    await loadLocaleMessages(appContext.locale);
  }, { immediate: true });
  return {
    localizationMap,
    locale
  }
});